import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserI } from './UserSlice.types'

const localStorageData: string | null =
  window.localStorage.getItem('userData') ??
  window.sessionStorage.getItem('userData')

const parsedLocalStorageData: Partial<UserI> = localStorageData
  ? JSON.parse(localStorageData)
  : undefined

export const initialState: UserI = {
  userName: parsedLocalStorageData?.userName ?? '',
  serverUrl: parsedLocalStorageData?.serverUrl ?? '',
  serverList: parsedLocalStorageData?.serverList ?? [],
  token: parsedLocalStorageData?.token ?? '',
  name: parsedLocalStorageData?.name ?? '',
  surname: parsedLocalStorageData?.name ?? ''
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (
      state,
      { payload }: PayloadAction<UserI & { rememberMe: boolean }>
    ) => {
      const { rememberMe, ...restPayload } = payload
      if (rememberMe) {
        window.localStorage.setItem('userData', JSON.stringify(payload))
      } else {
        window.sessionStorage.setItem('userData', JSON.stringify(payload))
      }
      document.cookie = `userToken=${payload.token};domain=.availroom.com;`
      Object.entries(restPayload).map(([key, value]) => {
        if (key in state) {
          state[key as keyof typeof state] = value as any
        }
        return null
      })
    },
    removeUser: (state) => {
      window.localStorage.removeItem('userData')
      window.sessionStorage.removeItem('userData')
      Object.keys(state).map((key) => {
        const value = state[key as keyof typeof state]
        if (typeof value === 'string') {
          ;(state[key as keyof typeof state] as any) = ''
        } else {
          ;(state[key as keyof typeof state] as any) = []
        }
        return null
      })
    }
  }
})

export const { setUser, removeUser } = userSlice.actions
